import React from "react";
import {
    ColumnLayout,
    Container,
    FormField,
    Header,
    SpaceBetween
} from "@amzn/awsui-components-react/polaris";
import {
    ComponentConstants,
    FremontBox,
    FremontButton,
    FremontCheckbox,
    requiredLabel
} from "utils/CommonComponents";
import { StageHeader } from "order/OrderCommonComponents";
import Constants from "utils/Constants";
import HelperFunctions from "common/HelperFunctions";

export const HardwareDeliveryInfoStageDisplayMode = props => (
    <div className="fremont-stage-spacing" ref={Constants.DEPENDENCY_LINK_REFERENCES[props.stageName].ref}>
        <Container
            header={
                <StageHeader
                    order={props.order}
                    disableEditButton={props.orderCompleted || props.editButtonsDisabled}
                    stageName={props.stageName}
                    handleStageEditClick={props.handleStageEditClick}
                    goToComponentAction={props.goToComponentAction}
                />
            }
        >
            <div>
                <ColumnLayout columns={2} borders="vertical">
                    <div>
                        <FremontBox label="Hardware Delivered:"/>
                        <div>{props.order.opticalMetaMap[Constants.ATTRIBUTES.isHardwareDelivered] &&
                        props.order.opticalMetaMap[Constants.ATTRIBUTES.isHardwareDelivered] === Constants.TRUE_STRING
                            ? Constants.YES_NO.yes : Constants.YES_NO.no}
                        </div>
                    </div>
                </ColumnLayout>
            </div>
        </Container>
    </div>
);

export const HardwareDeliveryInfoStageEditMode = props => (
    <div className="fremont-stage-spacing">
        <Container
            header={
                <Header
                    variant="h2"
                    actions={
                        <SpaceBetween direction="horizontal" size={ComponentConstants.SPACE_BETWEEN_BUTTON_PADDING}>
                            <FremontButton
                                id={props.stageName}
                                variant="normal"
                                onClick={props.handleStageEditClick}
                                disabled={props.isUpdateInProgress}
                            >
                                Cancel
                            </FremontButton>
                            <FremontButton
                                id={props.stageName}
                                loading={props.isUpdateInProgress}
                                variant="primary"
                                onClick={props.handleStageSubmit}
                            >
                                {props.isUpdateInProgress ? "Submitting..." : "Submit"}
                            </FremontButton>
                        </SpaceBetween>
                    }
                >
                    Hardware Delivery
                    {HelperFunctions.showStageStatusWithBlocker(props.updatedOrder
                        .stageStatusMap[props.stageName])
                    }
                </Header>
            }
        >
            <div>
                <ColumnLayout columns={2} borders="vertical">
                    <FormField
                        label={requiredLabel("Hardware Delivered:")}
                    >
                        <FremontCheckbox
                            id={Constants.ATTRIBUTES.isHardwareDelivered}
                            checked={
                                props.updatedOrder.opticalMetaMap[
                                    Constants.ATTRIBUTES.isHardwareDelivered
                                ]
                                === Constants.TRUE_STRING
                            }
                            onChange={props.handleStageInputChange}
                            disabled={props.isUpdateStageInProgress}
                        />
                    </FormField>
                </ColumnLayout>
            </div>
        </Container>
    </div>
);
